import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FlexGrid, CellType } from '@grapecity/wijmo.grid';
import { FlexGridFilter, FilterType } from '@grapecity/wijmo.grid.filter';
import { PlessDialogServiceSub } from 'src/app/commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from 'src/app/commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW9010Model } from './kymw9010.model';
import { KYMW9010OutputModel } from './vo/kymw9010-output.model';
import { KYMW00Model } from 'src/app/commons/kymw00/kymw00.model';
import { GetAssociatedCompanyListService } from './api-service/get-associated-company-list.service';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';

/**
 * 関連会社一覧画面を管理するクラス
 *
 * @export KYMW9010Component
 * @class KYMW9010Component
 */
@Component({
  selector: 'app-kymw9010',
  templateUrl: 'kymw9010.component.html',
  styleUrls: ['kymw9010.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW9010Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw9010Model: KYMW9010Model = new KYMW9010Model();

  setKYMW9010Parameter: Function;

  @ViewChild('dgt_associatedCompanyList', { static: true}) dgt_associatedCompanyList: FlexGrid;
  @ViewChild('fltr_associatedCompanyList', {static: true}) fltr_associatedCompanyList: FlexGridFilter;
  @ViewChild('fltr_tradeStopDivNameList', {static: true}) fltr_tradeStopDivNameList: FlexGridFilter;

  /** 関連会社区分値 制作会社 */
  private static readonly ASSOCIATED_COMPANY_PRODUCTION = '1';
  /** 関連会社区分値 スタジオ */
  private static readonly ASSOCIATED_COMPANY_STUDIO = '2';

  /**
   *Creates an instance of KYMW0400Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetSupplierListService} getSupplierListService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0400Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getAssociatedCompanyListService: GetAssociatedCompanyListService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW0400Component
   */
  public ngOnInit(): void {
    this.componentName = 'kymw9010';
    this.kymw9010Model.kymw9010Component = this;
    
    this.getAssociatedCompanyListService.execute(this.kymw9010Model, () => {
      if ( this.kymw9010Model.associatedCompanyList.length === 0 ) {
        this.dialogService.openAlertGetMessage("W0049", [''], (closeDetail) => {
          if (closeDetail === PlessAlert.Yes_Error) {
            this.onClickClose();
          }
        });
      }
    });
    this.dgt_associatedCompanyList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dgt_associatedCompanyList.select(-1, -1);
      this.dgt_associatedCompanyList.focus();
    });
  }

  public ngAfterViewInit(): void {
    // フィルタ設定
    if(this.kymw9010Model.associatedCompanyList) {
      this.fltr_associatedCompanyList.filterColumns = ['associatedCompanyName'];
      this.fltr_associatedCompanyList.showSortButtons = false;
      this.fltr_tradeStopDivNameList.filterColumns = ['tradeStopDivName'];
      this.fltr_tradeStopDivNameList.showSortButtons = false;
    }
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 親画面からのパラメーターassociatedUserType(ユーザ区分)は2：スタジオ、3：制作会社
   * @memberof KYMW9010Component
   */
  public setInterfaceParam(param: any): void {
    // 関連会社区分(1:制作会社、2:スタジオ)を保持
    if (param === KYMW00Model.ASSOCIATED_USER_TYPE_PRODUCTION) {
      this.kymw9010Model.associatedCompanyType = KYMW9010Component.ASSOCIATED_COMPANY_PRODUCTION; // 制作会社
    } else if (param === KYMW00Model.ASSOCIATED_USER_TYPE_STUDIO) {
      this.kymw9010Model.associatedCompanyType = KYMW9010Component.ASSOCIATED_COMPANY_STUDIO; // スタジオ
    }
  }

  /**
   * 選択ボタン クリックイベント処理
   *
   */
  public eventRegistUser_CLICKHandler(): void {
    // 選択行が無い場合
    if (PlessViewUtilsSub.isEmptyArray(this.dgt_associatedCompanyList.selectedItems)) {
      // 処理復帰
      return;
    }

    // 呼び出し元画面に選択行データを返却
    const outputVO: KYMW9010OutputModel = new KYMW9010OutputModel();
    outputVO.associatedCompanyId = this.dgt_associatedCompanyList.selectedItems[0].associatedCompanyId;
    outputVO.associatedCompanyName = this.dgt_associatedCompanyList.selectedItems[0].associatedCompanyName;

    // 呼び出し元画面に値を返す
    this.setKYMW9010Parameter(outputVO);

    // 閉じる
    super.onClickClose();
  }
}
